import React from "react";
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Stack } from "@/components/ui/layout";
import { Text } from "@/components/ui/typography";
import { Mic, FileText } from 'lucide-react';

const JDModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleAudio = () => {
    onClose();
    navigate('/jdaudio');
  };
  const handleText = () => {
    onClose();
    navigate('/jdai');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Generate Job Description with AI</DialogTitle>
          <DialogDescription>
            Choose how you want to generate the job description:
          </DialogDescription>
        </DialogHeader>
        <Stack spacing="md" className="mt-4">
          <Button
            onClick={handleAudio}
            className="w-full justify-start gap-3 h-auto py-4"
            variant="outline"
          >
            <Mic className="w-5 h-5" />
            <div className="text-left">
              <div className="font-semibold">Generate JD with Audio</div>
              <Text variant="muted" className="text-xs">Record your requirements</Text>
            </div>
          </Button>
          <Button
            onClick={handleText}
            className="w-full justify-start gap-3 h-auto py-4"
            variant="outline"
          >
            <FileText className="w-5 h-5" />
            <div className="text-left">
              <div className="font-semibold">Generate JD with Text</div>
              <Text variant="muted" className="text-xs">Type your requirements</Text>
            </div>
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default JDModal;
